import { toast } from "react-toastify"
import { fetchConnecitonData } from "../../../services/managerBotApis"
import Input from "../../Input"

const Connection = ({ values, setServerData }) => {
    const testConnection = () => {
        let data = {
            host: document.getElementById("connection-host").value,
            serverPort: document.getElementById("connection-serverport").value,
            queryPort: document.getElementById("connection-queryport").value,
            username: document.getElementById("connection-username").value,
            password: document.getElementById("connection-querypassword").value,
        }
        console.log(data)

        toast
            .promise(fetchConnecitonData(data), {
                pending: "درحال اتصال",
                success: "متصل شد",
            })
            .then((res) => {
                console.log(res)
                setServerData(res.data)
            })
            .catch(() => {})
    }

    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">کانکشن</h6>
            <div className="grid grid-cols-3 gap-5 mb-16">
                <div className="">
                    <Input
                        type="text"
                        name="connection-host"
                        label="ایپی سرور *"
                        placeholder="ip/domain"
                        autoComplete="off"
                        defaultValue={values?.host}
                        required
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        label="سرور پورت *"
                        name="connection-serverport"
                        placeholder="serverport"
                        autoComplete="off"
                        defaultValue={values?.serverPort}
                        required
                    />
                </div>

                <div className="">
                    <Input
                        type="text"
                        label="پورت کوئری *"
                        name="connection-queryport"
                        placeholder="queryport"
                        autoComplete="off"
                        defaultValue={values?.queryPort}
                        required
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-5">
                <div className="">
                    <Input
                        type="text"
                        name="connection-username"
                        label="یوزر کوئری *"
                        placeholder="serveradmin"
                        autoComplete="off"
                        defaultValue={values?.username}
                        required
                    />
                </div>
                <div className="">
                    <Input
                        type="text"
                        name="connection-querypassword"
                        label="پسورد کوئری *"
                        placeholder="پسورد کوئری"
                        autoComplete="off"
                        defaultValue={values?.queryPassword}
                        required
                    />
                </div>
            </div>
            <div className="">
                <Input
                    type="text"
                    name="connection-botname"
                    label="اسم بات *"
                    placeholder="اسم بات"
                    autoComplete="off"
                    defaultValue={values?.botName}
                    required
                />
            </div>

            <button type="button" onClick={testConnection} className="mt-5 styled-button">
                تست کانکشن
            </button>
        </div>
    )
}

export default Connection
